import classNames from 'classnames';
import { FC, memo } from 'react';
import { IInputProps } from '../../types';
import './style.scss';

type TProps = Pick<IInputProps, 'placeholder' | 'movablePlaceholder' | 'required'>;
interface IProps extends TProps {
  focused: boolean;
}

const InputMovablePlaceholder: FC<IProps> = ({ placeholder, movablePlaceholder, focused, required }: IProps): JSX.Element | null => {
  const className: string = classNames('input-new__movable-placeholder', { required, 'input-new__movable-placeholder_focused': focused });

  if (!placeholder || !movablePlaceholder) return null;

  return <p className={className}>{placeholder}</p>;
};

export default memo(InputMovablePlaceholder);
